import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

const BANK_METHODS = ["BANRURAL", "BANCO_INDUSTRIAL"];

export default class UnifyPay extends Base {
	constructor(props) {
		super(props);
		this.state = {
			...this.state,
			customerFirstName: "",
			customerLastName: "",
			customerAccountType: "",
			customerAccountNumber: "",
		};
	}

	getMethodName() {
		const { method } = this.props;
		return method.replace("88Pay", "");
	}

	isBankMethod() {
		return BANK_METHODS.includes(this.getMethodName());
	}

	getStep1(translate) {
		const { customerFirstName, customerLastName, customerAccountType, customerAccountNumber } =
			this.state;

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				{this.isBankMethod() && (
					<>
						<FormItem
							onRegister={() => this.registerField({ name: "customerFirstName" })}
						>
							<Box>
								<BoxTitle>{translate("FIRST_NAME")}</BoxTitle>
								<StakeInput
									type="text"
									placeholder="..."
									value={customerFirstName}
									onChange={this.onEnterValue.bind(this, "customerFirstName")}
								/>
							</Box>
						</FormItem>
						<FormItem
							onRegister={() => this.registerField({ name: "customerLastName" })}
						>
							<Box>
								<BoxTitle>{translate("LAST_NAME")}</BoxTitle>
								<StakeInput
									type="text"
									placeholder="..."
									value={customerLastName}
									onChange={this.onEnterValue.bind(this, "customerLastName")}
								/>
							</Box>
						</FormItem>
						<FormItem
							onRegister={() => this.registerField({ name: "customerAccountType" })}
						>
							<Box>
								<BoxTitle>{translate("ACCOUNT_TYPE")}</BoxTitle>
								<PaymentSelect
									value={customerAccountType}
									options={[
										{ value: "Checking", label: "Checking" },
										{ value: "Savings", label: "Savings" },
									]}
									handleSelect={(e) =>
										this.setState({ customerAccountType: e.value })
									}
								/>
							</Box>
						</FormItem>
						<FormItem
							onRegister={() =>
								this.registerField({ name: "customerAccountNumber" })
							}
						>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									type="text"
									placeholder="..."
									value={customerAccountNumber}
									onChange={this.onEnterValue.bind(
										this,
										"customerAccountNumber"
									)}
								/>
							</Box>
						</FormItem>
					</>
				)}
			</Content>
		);
	}

	makeExternalPayment() {
		const {
			stake,
			selectedCurrency,
			customerFirstName,
			customerLastName,
			customerAccountType,
			customerAccountNumber,
		} = this.state;

		const methodName = this.getMethodName();

		const withdrawData = {
			type: "88Pay",
			method: methodName,
			username: getUser().username,
			amount: {
				value: Number(stake),
				currency: selectedCurrency,
			},
		};

		if (this.isBankMethod()) {
			withdrawData.customer = {
				customer_first_name: customerFirstName,
				customer_last_name: customerLastName,
				customer_account_identifier_value_type: customerAccountType,
				customer_account_identifier_value: customerAccountNumber,
			};
		}

		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
